import React from 'react';
import { Box } from '@atoms';

export default function DeviceIssues() {
  return <Box>device issues</Box>;
}
